/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';
import type { CompanyPartyDetailsViewModel } from './CompanyPartyDetailsViewModel';
import {
    CompanyPartyDetailsViewModelFromJSON,
    CompanyPartyDetailsViewModelFromJSONTyped,
    CompanyPartyDetailsViewModelToJSON,
} from './CompanyPartyDetailsViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { ThirdPartyOrganisationFinancialAndTax } from './ThirdPartyOrganisationFinancialAndTax';
import {
    ThirdPartyOrganisationFinancialAndTaxFromJSON,
    ThirdPartyOrganisationFinancialAndTaxFromJSONTyped,
    ThirdPartyOrganisationFinancialAndTaxToJSON,
} from './ThirdPartyOrganisationFinancialAndTax';

/**
 * 
 * @export
 * @interface CompanyThirdPartyViewModel
 */
export interface CompanyThirdPartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof CompanyThirdPartyViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {CompanyPartyDetailsViewModel}
     * @memberof CompanyThirdPartyViewModel
     */
    companyDetails?: CompanyPartyDetailsViewModel;
    /**
     * 
     * @type {ThirdPartyOrganisationFinancialAndTax}
     * @memberof CompanyThirdPartyViewModel
     */
    financialAndTax?: ThirdPartyOrganisationFinancialAndTax;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof CompanyThirdPartyViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof CompanyThirdPartyViewModel
     */
    registeredAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the CompanyThirdPartyViewModel interface.
 */
export function instanceOfCompanyThirdPartyViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyThirdPartyViewModelFromJSON(json: any): CompanyThirdPartyViewModel {
    return CompanyThirdPartyViewModelFromJSONTyped(json, false);
}

export function CompanyThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'companyDetails': !exists(json, 'CompanyDetails') ? undefined : CompanyPartyDetailsViewModelFromJSON(json['CompanyDetails']),
        'financialAndTax': !exists(json, 'FinancialAndTax') ? undefined : ThirdPartyOrganisationFinancialAndTaxFromJSON(json['FinancialAndTax']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'registeredAddress': !exists(json, 'RegisteredAddress') ? undefined : AddressViewModelFromJSON(json['RegisteredAddress']),
    };
}

export function CompanyThirdPartyViewModelToJSON(value?: CompanyThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'CompanyDetails': CompanyPartyDetailsViewModelToJSON(value.companyDetails),
        'FinancialAndTax': ThirdPartyOrganisationFinancialAndTaxToJSON(value.financialAndTax),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'RegisteredAddress': AddressViewModelToJSON(value.registeredAddress),
    };
}

